export const StepCode = {
  Type: 0,
  Content: 1,
  Deadline: 2,
  Barcode: 3,
  Resolutions: 4,
  Files: 5,
  Links: 6,
  Clients: 7,
  Route: 8,
  Contractor: 9,
  Execution: 10,
  Launch: 11,
  Registration: 12,
} as const;

export type StepCode = (typeof StepCode)[keyof typeof StepCode];
